import {
  SectionElement,
  defineElement,
  on,
  query,
  queryAll
} from "./chunk-DNDL4K7L.js";
import {
  __decorateClass
} from "./chunk-RGTSXKO2.js";

// src/sections/common-collection-grid/common-collection-grid.ts
var CommonCollectionGrid = class extends SectionElement {
  showAllLinks() {
    this.linkBlocks.forEach((block) => {
      block.classList.remove("hidden");
    });
    this.showAllButton.remove();
  }
};
__decorateClass([
  queryAll("[data-funnel-link-block]")
], CommonCollectionGrid.prototype, "linkBlocks", 2);
__decorateClass([
  query("[data-show-all-links]")
], CommonCollectionGrid.prototype, "showAllButton", 2);
__decorateClass([
  on("click", "[data-show-all-links]")
], CommonCollectionGrid.prototype, "showAllLinks", 1);
CommonCollectionGrid = __decorateClass([
  defineElement("common-collection-grid")
], CommonCollectionGrid);
export {
  CommonCollectionGrid
};
